
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0a294a","d":"M1.475 16.604c-.244 0-.442.2-.442.447v.193c0 .247.198.447.442.447h1.52c.244 0 .442-.2.442-.447v-.193a.445.445 0 00-.443-.447zM5.467 4.177C5.133 6.573 6.595 8.85 8.897 9.52v7.084H5.363l-.085.011a.324.324 0 00-.236.309v.829l-.01.078a.296.296 0 01-.281.22H.434l-.087.009a.438.438 0 00-.347.43v3.464l.009.089c.04.2.215.35.425.35h19.65l.087-.009a.438.438 0 00.347-.43V18.49l-.01-.089a.435.435 0 00-.424-.35h-4.34l-.075-.01a.285.285 0 01-.207-.275v-.842l-.011-.085a.317.317 0 00-.306-.235h-3.593V9.52l.243-.077c2.16-.754 3.508-2.956 3.186-5.266-.334-2.396-2.363-4.178-4.757-4.178-2.394 0-4.423 1.782-4.757 4.178z"}})])
          )
        }
      }
    